<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">调用接口</h1>
		<h3 class="doc_main_h3">拍摄识别</h3>
		<h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">PluginImportManage.Instance.SKEyeSDKPhotograph();
//可以参考 CameraRecognition.cs 
</code></pre>
		<h3 class="doc_main_h3">图片路径识别</h3>
		<h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">PluginImportManage.Instance.SKEyeSDKRoute(URL);
//可以参考 RouteRecognition.cs 
</code></pre>
		<h3 class="doc_main_h3">识别结果接收 </h3>
		<h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">void Start(){         
	PluginImportManage.Instance.MouseOver += Listener;   
}  
void Listener(string _ResurtStr){        
 	Debug.Log("识别结果 ="+ _ResurtStr);
}</code></pre>
		<h3 class="doc_main_h3">开启摄像头</h3>
		<h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">WebCameraImg.Instance.PlayWebCamera();</code></pre>
		<h3 class="doc_main_h3">关闭摄像头</h3>
		<h4 class="doc_main_h4">函数</h4>
		<pre class="doc_main_pre"><code class="doc_main_code">WebCameraImg.Instance.StopWebCamera();</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../components/documentTitleBar';
	import SKEyeJson from '../../../components/SKEyeJson'
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'sk-eye-json':SKEyeJson,
		},
		data(){
			return{
				isPathData:['物体识别','SKEye-Unity','调用接口'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skeyeunity/callImageInterface.vue